// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"global-module--maxWidth--1BybX","header":"global-module--header--1O6kZ"};